import {
  FETCH_RAW_STOCK_CODES_REQUEST,
  FETCH_RAW_STOCK_CODES_SUCCESS,
  FETCH_RAW_STOCK_CODES_FAILURE,
  CREATE_RAW_STOCK_CODE_REQUEST,
  CREATE_RAW_STOCK_CODE_SUCCESS,
  CREATE_RAW_STOCK_CODE_FAILURE,
  UPDATE_RAW_STOCK_CODE_REQUEST,
  UPDATE_RAW_STOCK_CODE_SUCCESS,
  UPDATE_RAW_STOCK_CODE_FAILURE,
  DELETE_RAW_STOCK_CODE_REQUEST,
  DELETE_RAW_STOCK_CODE_SUCCESS,
  DELETE_RAW_STOCK_CODE_FAILURE
} from '../../types/rawStockCode/rawStockCodeTypes';
import {
  fetchRawStockCodes as fetchRawStockCodesApi,
  createRawStockCode as createRawStockCodeApi,
  updateRawStockCode as updateRawStockCodeApi,
  deleteRawStockCode as deleteRawStockCodeApi
} from '../../../api/rawStockCode/rawStockCodeApi';

export const getRawStockCodes = () => async (dispatch) => {
  dispatch({ type: FETCH_RAW_STOCK_CODES_REQUEST });
  try {
    const { data } = await fetchRawStockCodesApi();
    dispatch({ type: FETCH_RAW_STOCK_CODES_SUCCESS, payload: data });
  } catch (error) {
    const errorMessage = error?.response?.data?.message || 'Failed to fetch raw stock codes';
    dispatch({ type: FETCH_RAW_STOCK_CODES_FAILURE, payload: errorMessage });
  }
};

// Export the old function name for backward compatibility
export const fetchRawStockCodes = getRawStockCodes;

export const addRawStockCode = (rawStockCode) => async (dispatch) => {
  dispatch({ type: CREATE_RAW_STOCK_CODE_REQUEST });
  try {
    const { data } = await createRawStockCodeApi(rawStockCode);
    dispatch({ type: CREATE_RAW_STOCK_CODE_SUCCESS, payload: data });
    return { success: true, data };
  } catch (error) {
    const errorMessage = error?.response?.data?.message || 'Failed to create raw stock code';
    dispatch({ type: CREATE_RAW_STOCK_CODE_FAILURE, payload: errorMessage });
    return { success: false, error: errorMessage };
  }
};

// Export the old function name for backward compatibility
export const createRawStockCode = addRawStockCode;

export const updateRawStockCodeAction = (id, rawStockCode) => async (dispatch) => {
  dispatch({ type: UPDATE_RAW_STOCK_CODE_REQUEST });
  try {
    const { data } = await updateRawStockCodeApi(id, rawStockCode);
    dispatch({ type: UPDATE_RAW_STOCK_CODE_SUCCESS, payload: data });
    return { success: true, data };
  } catch (error) {
    const errorMessage = error?.response?.data?.message || 'Failed to update raw stock code';
    dispatch({ type: UPDATE_RAW_STOCK_CODE_FAILURE, payload: errorMessage });
    return { success: false, error: errorMessage };
  }
};

// Export the old function name for backward compatibility
export const updateRawStockCode = updateRawStockCodeAction;

export const deleteRawStockCodeAction = (id) => async (dispatch) => {
  dispatch({ type: DELETE_RAW_STOCK_CODE_REQUEST });
  try {
    await deleteRawStockCodeApi(id);
    dispatch({ type: DELETE_RAW_STOCK_CODE_SUCCESS, payload: id });
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error?.message || 'Failed to delete raw stock code';
    dispatch({ type: DELETE_RAW_STOCK_CODE_FAILURE, payload: errorMessage });
  }
};

// Export the old function name for backward compatibility
export const deleteRawStockCode = deleteRawStockCodeAction; 